import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './historyofnutrition.json';

const Historyofnutrition = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout

            description="The history of nutrition, healthy eating guidelines, and food vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="History of Nutrition"
            image="/Images/history-of-nutrition.webp"
            seoTitle="Free English Lesson Plans: History of Nutrition"
            seoDescription="The history of nutrition, healthy eating guidelines, and food vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Historyofnutrition;
